import { Skeleton } from '@accure/ui';

import { ProjectShell } from '@/project-management/components/layout/project-shell';

export function WorkstreamsLoading() {
  return (
    <ProjectShell className="space-y-4">
      <div className="flex items-baseline justify-between">
        <Skeleton className="h-7 w-40" />
        <Skeleton className="h-5 w-12" />
      </div>

      <div className="space-y-6">
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
      </div>
    </ProjectShell>
  );
}
